export const SET_CREDENTIAL = 'SET CREDENTIALS'